import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, IconButton, Badge, InputBase, Avatar, Chip } from '@mui/material';
import { Notifications, Search, Settings } from '@mui/icons-material';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import { useAuth } from '../../context/AuthContext';

const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard', '/hospitals': 'Hospitals', '/patients': 'Patients',
  '/appointments': 'Appointments', '/inventory': 'Inventory', '/billing': 'Billing',
  '/staff': 'Staff', '/doctors': 'Doctors', '/departments': 'Departments',
};

const Layout = () => {
  const { user } = useAuth();
  const location = useLocation();
  const title = Object.entries(pageTitles).find(([k]) => location.pathname.startsWith(k))?.[1] || 'HMS';

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f0fdfa' }}>
      <Sidebar />
      <Box sx={{ flex: 1, ml: `${DRAWER_WIDTH}px`, display: 'flex', flexDirection: 'column' }}>

        {/* Top Bar */}
        <AppBar position="sticky" elevation={0} sx={{ bgcolor: 'white', borderBottom: '1px solid #f1f5f9', zIndex: 99 }}>
          <Toolbar sx={{ minHeight: '64px !important', px: 3, gap: 2 }}>

            {/* Search */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#f8fafc', borderRadius: 3, px: 2, py: 0.8, flex: 1, maxWidth: 380, border: '1px solid #e2e8f0', '&:focus-within': { borderColor: '#0d9488', bgcolor: '#f0fdfa' }, transition: 'all 0.2s' }}>
              <Search sx={{ color: '#94a3b8', fontSize: 18 }} />
              <InputBase placeholder="Search patients, doctors, appointments..." sx={{ fontSize: 13, color: '#0f172a', flex: 1, '& ::placeholder': { color: '#94a3b8' } }} />
            </Box>

            <Box sx={{ flex: 1 }} />

            {/* Right Actions */}
            <IconButton size="small" sx={{ bgcolor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 2 }}>
              <Settings sx={{ fontSize: 18, color: '#64748b' }} />
            </IconButton>
            <IconButton size="small" sx={{ bgcolor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 2 }}>
              <Badge badgeContent={3} color="error" sx={{ '& .MuiBadge-badge': { fontSize: 10, minWidth: 16, height: 16 } }}>
                <Notifications sx={{ fontSize: 18, color: '#64748b' }} />
              </Badge>
            </IconButton>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 1.5, borderLeft: '1px solid #f1f5f9' }}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: '#ccfbf1', color: '#0d9488', fontSize: 13, fontWeight: 800 }}>
                {user?.name?.charAt(0)}
              </Avatar>
              <Box sx={{ display: 'none', '@media (min-width: 900px)': { display: 'block' } }}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#0f172a', lineHeight: 1 }}>{user?.name}</Typography>
                <Typography sx={{ fontSize: 11, color: '#94a3b8', textTransform: 'capitalize' }}>{user?.role}</Typography>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box sx={{ flex: 1, p: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
